import { OnInit, EventEmitter, Optional } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap/modal";

export class ModalsComponent implements OnInit {
  action: EventEmitter<any> = new EventEmitter();  

  constructor(
    @Optional() public modalRef:BsModalRef
  ) { }

  ngOnInit() {
  }
  ok (data:any = true) {
    if (this.modalRef) {
      this.modalRef.hide(); 
      this.action.emit(data);
    }
    else {
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
      
      const target = window.location.origin;
      // const target = '*';
      // const application_id = urlParams.get('application_id');
      // validate application_id
  
      if (window.opener) { // pop-up
        window.opener.parent.postMessage({data, state}, target); 
        setTimeout(()=>window.close());    
      }
      else if (window.location !== window.parent.location) { // iframe
        window.parent.postMessage({data, state}, target);
      }
      else {
        console.debug(data);
      }

    }

  }
  cancel () {
    if (this.modalRef) { // modal
      this.modalRef.hide(); 
      this.action.emit(false);
    }
    else {
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
  
      if (window.opener) { // pop-up
        window.opener.parent.postMessage({data:false, state}, '*'); 
        setTimeout(()=>window.close());    
      }
      else if (window.location !== window.parent.location) { // iframe
        window.parent.postMessage({data:false, state}, '*');
      }
      else {
        console.debug(false);
      }
  
    }
  }
}
